export default function appConfig(): AppConfig {
    return APP_CONFIG;
}

export function getDefaultDigitalRatePlan(): string {
    return appConfig().counterOffers[0];
}
